// extracted by mini-css-extract-plugin
export var searchHeader = "_6y-0";
export var searchHeaderDark = "_6y-1";